module.exports = __webpack_public_path__ + "static/media/22ESCWA16.f1069d70.jpg";